import { createActionCreator } from "common/ReduxUtils";
import { StorageDestinationActionTypes } from "../StorageDestinationAction.types";
import { StorageWarehouseSellerView } from "../StorageWarehouseSellerView";
import { WarehousePublic } from "@deliverr/business-types";

export const setStorageWarehouses = createActionCreator<(StorageWarehouseSellerView | WarehousePublic)[]>(
  StorageDestinationActionTypes.STORAGE_SET_WAREHOUSE_LIST,
  "storageWarehouses"
);
